
export function calculatePlayerOvr(player) {
    let ovr = player.originalOvr;

    let increasingState = 0;

    const keys = ['s1', 's2', 's3', 's4', 's5', 's6'];

    keys.forEach((key) => {
        increasingState += player.trainedStates[key] || 0;
        increasingState += player.specialTrainedStates[key] || 0;
        increasingState += player.positionTrainedStates[key] || 0;
        increasingState += player.positionTrainedAdditionalStates[key] || 0;
        increasingState += player.enforcedStates[key] || 0;
        increasingState += player.awakenStates[key] || 0;
        increasingState += player.setDeckStates[key] || 0;
        increasingState += player.synergyStates[key] || 0;
        increasingState += player.faStates[key] || 0;
    });

    return ovr + Math.floor(increasingState / 6);
}

export function calculateTotalPlayerOvr(playerInfos) {
    let totalOvr = 0;

    const positionKeys = [
    'LF', 'CF', 'RF', 'SS', '2B', '1B', '3B', 'C', 'DH', 
    'SUB1', 'SUB2', 'SUB3', 'SUB4', 'SUB5', 'SUB6', 
    'SP1', 'SP2', 'SP3', 'SP4', 'SP5', 
    'RP1', 'RP2', 'RP3', 'RP4', 'RP5', 'RP6', 'CP'
    ]

    for (const positionKey of positionKeys) {

        const player = playerInfos[positionKey];
        if (player) {
            totalOvr += calculatePlayerOvr(player);
        } 
    }

    const result = Math.floor((totalOvr/positionKeys.length) * 10) / 10

    return result;
}

export function calculateBatterPlayerOvr(playerInfos) {
    let totalOvr = 0;

    const positionKeys = [
    'LF', 'CF', 'RF', 'SS', '2B', '1B', '3B', 'C', 'DH', 
    'SUB1', 'SUB2', 'SUB3', 'SUB4', 'SUB5', 'SUB6'
    ]

    for (const positionKey of positionKeys) {

        const player = playerInfos[positionKey];
        if (player) {
            totalOvr += calculatePlayerOvr(player);
        } 
    }

    const result = Math.floor((totalOvr/positionKeys.length) * 10) / 10

    return result;
}

export function calculatePitcherPlayerOvr(playerInfos) {
    let totalOvr = 0;
    const positionKeys = [
    'SP1', 'SP2', 'SP3', 'SP4', 'SP5', 
    'RP1', 'RP2', 'RP3', 'RP4', 'RP5', 'RP6', 'CP'
    ]   
    for (const positionKey of positionKeys) {

        const player = playerInfos[positionKey];
        if (player) {
            totalOvr += calculatePlayerOvr(player);
        }
    }

    const result = Math.floor((totalOvr/positionKeys.length) * 10) / 10

    return result;
}